import styled from "styled-components";

export const Wrapper = styled.span`
  display: inline;
  white-space: normal;
  vertical-align: top;
  font-size: 15px !important;
  font-weight: 400 !important;
  *:not(strong) {
    font-size: 15px !important;
    font-weight: 400 !important;
  }
  strong {
    font-weight: 600 !important;
    * {
      font-weight: 600 !important;
    }
  }
  font-weight: unset !important;

  a {
    all: unset;
  }

  &:focus {
    outline: none;
    border: none;
    padding: 0;
    margin: 0;
  }
`;

export const Text = styled.span``;
